import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function NavLink({ to, children, onClick, className }) {
  const location = useLocation();
  const isActive = location.pathname === to;
  
  return (
    <Link 
      to={to} 
      className={`${isActive ? 'active' : ''} ${className || ''}`}
      onClick={onClick}
    >
      {children}
    </Link>
  );
}

export default NavLink;